import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import "bootstrap/dist/css/bootstrap.min.css";
import prev from "../assets/prev.png";
import next from "../assets/next.png";

function importAll(r) {
    return r.keys().map((key, idx) => ({
        id: idx,
        url: r(key),
        alt: key.replace('./', ''),
    }));
}

const carouselImages = importAll(require.context('../assets/carousel', false, /\.(png|jpe?g|svg)$/));
const carouselImagesMobile = importAll(require.context('../assets/carousel_mobile', false, /\.(png|jpe?g|svg)$/));

const CarouselBanner = ({
    images = carouselImages,
    transitionDuration = 3000, // in ms
}) => {
    const [activeIndex, setActiveIndex] = useState(0);
    const timerRef = useRef(null);
    const [currentImages, setCurrentImages] = useState(images);


    useEffect(() => {
        if (currentImages.length <= 1) return;

        timerRef.current = setInterval(() => {
            setActiveIndex((prev) => (prev + 1) % images.length);
        }, transitionDuration);
        return () => clearInterval(timerRef.current);
    }, [images.length, transitionDuration]);

    useEffect(() => {
        const mediaQuery = window.matchMedia("(max-width: 768px)");

        const updateImages = () => {
            setCurrentImages(mediaQuery.matches ? carouselImagesMobile : images);
        };

        updateImages(); // Set initial images
        mediaQuery.addEventListener("change", updateImages);

        return () => mediaQuery.removeEventListener("change", updateImages);
    }, [images]);


    const goToIndex = (idx) => {
        setActiveIndex(idx);
        resetTimer();
    };

    const prevSlide = () => {
        setActiveIndex((prev) => (prev - 1 + images.length) % images.length);
        resetTimer();
    };

    const nextSlide = () => {
        setActiveIndex((prev) => (prev + 1) % images.length);
        resetTimer();
    };

    const resetTimer = () => {
        clearInterval(timerRef.current);
        timerRef.current = setInterval(() => {
            setActiveIndex((prev) => (prev + 1) % images.length);
        }, transitionDuration);
    };

    return (
        <div className="position-relative w-100 overflow-hidden">
            <div
                className="carousel-inner custom-carousel-inner d-flex"
                style={{
                    width: `${currentImages.length * 100}%`,
                    transform: `translateX(-${activeIndex * (100 / currentImages.length)}%)`,
                    transition: "transform 0.7s cubic-bezier(0.4,0,0.2,1)",
                }}
            >
                {currentImages.map((img, idx) => (
                    <div
                        className="carousel-item-custom"
                        key={img.id || idx}
                        style={{
                            width: `${100 / currentImages.length}%`,
                            flex: "0 0 auto",
                            transition: "opacity 0.5s",
                        }}
                    >
                        <img
                            src={img.url}
                            className="d-block w-100"
                            alt={img.alt || `Slide ${idx + 1}`}
                            style={{
                                objectFit: "contain", // ubah dari "cover" ke "contain"
                                height: "100%",
                                borderRadius: "50px",
                                background: "#fff" // opsional, agar area kosong putih
                            }}
                        />
                    </div>
                ))}
            </div>
            {/* Prev Button */}
            <button
                className="carousel-control-prev"
                type="button"
                style={{
                    top: "50%",
                    transform: "translateY(-50%)",
                    left: "10px",
                    width: "70px",
                    height: "70px",
                    background: "rgba(0,0,0,0.3)",
                    border: "none",
                    borderRadius: "50%",
                    zIndex: 2,
                }}
                onClick={prevSlide}

            >
                <img src={prev} alt="Previous" style={{ width: 17, height: 60 }} />
                <span className="visually-hidden">Previous</span>
            </button>
            {/* Next Button */}
            <button
                className="carousel-control-next"
                type="button"
                style={{
                    top: "50%",
                    transform: "translateY(-50%)",
                    right: "10px",
                    width: "70px",
                    height: "70px",
                    background: "rgba(0,0,0,0.3)",
                    border: "none",
                    borderRadius: "50%",
                    zIndex: 2,
                }}
                onClick={nextSlide}
            >
                <img src={next} alt="Next" style={{ width: 17, height: 60 }} />

                <span className="visually-hidden">Next</span>
            </button>
            {/* Dots */}
            <div className="carousel-indicators" style={{ bottom: "10px" }}>
                {currentImages.map((_, idx) => (
                    <button
                        key={idx}
                        type="button"
                        className={idx === activeIndex ? "active" : ""}
                        aria-current={idx === activeIndex}
                        aria-label={`Slide ${idx + 1}`}
                        style={{
                            width: "10px",
                            height: "10px",
                            borderRadius: "50%",
                            margin: "0 4px",
                            background: idx === activeIndex ? "#0d6efd" : "#fff",
                            border: "0px solid #0d6efd",
                            outline: "none",
                            opacity: 1,
                        }}
                        onClick={() => goToIndex(idx)}
                    />
                ))}
            </div>
        </div>
    );
};

CarouselBanner.propTypes = {
    images: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            url: PropTypes.string.isRequired,
            alt: PropTypes.string,
        })
    ),
    transitionDuration: PropTypes.number,
};

export default CarouselBanner;